import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    minHeight: '1.5rem'
  },

  input: {
    margin: '0.5rem 0',
    border: `1px solid ${theme.palette.primary.light}`,
    borderRadius: '0.25rem',
    width: '100%',
    padding: '0.375rem',
    paddingRight: '1.25rem',
    outline: 'none',
    color: 'rgba(127, 132, 135, 0.5)',
    fontSize: theme.size.sm,

    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  },

  cancel: {
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer'
  }
}))

export default useStyles
